import { render, staticRenderFns } from "./ListiniEdit.vue?vue&type=template&id=b3a6e4a2&"
import script from "./ListiniEdit.vue?vue&type=script&lang=ts&"
export * from "./ListiniEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports